<template>
  <main class="staff-page">
    <div v-if="loading" class="ui-empty">
      <Spinner />
      <span>Загрузка продукта…</span>
    </div>
    <p v-else-if="errorMessage" role="alert" class="ui-alert ui-alert--error">{{ errorMessage }}</p>
    <template v-else-if="product">
      <Button as-child variant="ghost" class="mb-5">
        <router-link :to="{ name: 'products' }">
          <ArrowLeft :size="16" />
          К списку продуктов
        </router-link>
      </Button>
      <header class="page-heading">
        <div class="flex items-center gap-4">
          <span class="catalog-icon">
            <img v-if="product.icon" :src="product.icon" :alt="product.name" />
            <Package v-else :size="26" />
          </span>
          <h1>{{ product.name }}</h1>
        </div>
      </header>
      <product-modules-tree :modules="product.modules || []" />
    </template>
  </main>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { Package, ArrowLeft } from '@lucide/vue';

import { onMounted, ref } from 'vue';
import axios from 'axios';
import ProductModulesTree from '@/components/ProductModulesTree.vue';

interface Props {
  id: number;
}

const props = defineProps<Props>();

const loading = ref(false);
const errorMessage = ref('');
const product = ref<Product | null>(null);

async function loadProduct() {
  loading.value = true;
  errorMessage.value = '';
  try {
    product.value = (await axios.get(`/api/products/${props.id}/`)).data as Product;
  } catch (error) {
    console.error('Failed to load product details:', error);
    errorMessage.value = 'Не удалось загрузить карточку продукта';
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await loadProduct();
});
</script>
